import { lazyRetry } from "helpers/lazyRetry";

const Liquidations_L = lazyRetry(() => import("./Liquidations"));

export default Liquidations_L;
